import Model from '@/models/Model.js';

export default class ActivitySettingsTemplate extends Model {
    static entity = 'activity_settings_templates';

    static modelName = 'ActivitySettingsTemplate';

    static fields() {
        return {
            id: this.attr(null),
            max_attempts_allowed: this.attr(null),
            allow_submissions_after_due_date: this.attr(null),
            week_due: this.attr(null),
            day_due: this.attr(null),
            time_due: this.attr(null),
            points_possible: this.attr(null),
            auto_grade: this.attr(null),
            week_visible: this.attr(null),
            day_visible: this.attr(null),
            time_visible: this.attr(null),
            is_extra_credit: this.attr(null),
            is_for_attendance: this.boolean(null),
            course_authorized_role_id: this.number(null),
            minimum_passing_score: this.attr(null),
            ...super.fields(),

            activityTemplate: this.hasOne('activity_templates', 'activity_template_id'),
            activitySettings: this.hasMany('activity_settings', 'activity_settings_id'),
        };
    }
}
